import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/',                          name:'Home',                component: Home  },
  { path: '/company',                   name:'company',             component: () => import('@/views/company.vue'),
    meta: {
      cate: 1,
      pageTitle: 'Vision', 
      breadcrumb: [
        { 
          text: 'Home',
          disabled: false,
          to: '/'
        },
        { 
          text: 'Company',
          disabled: false,
        },
        {
          text: 'Vision',
          disabled: false,
        },
      ],
    },
  },
  // { path: '/company/vision',            name:'vision',              component: () => import('@/views/company/vision.vue'),
  //   meta: {
  //     cate: 1,
  //     pageTitle: 'Vision', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Company',
  //         disabled: false,
  //       },
  //       {
  //         text: 'Vision',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  // { path: '/company/ceo',               name:'ceo',                 component: () => import('@/views/company/ceo.vue'), 
  //   meta: {
  //     cate: 1,
  //     pageTitle: 'CEO Message', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Company',
  //         disabled: false,
  //       },
  //       {
  //         text: 'CEO Message',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  // { path: '/company/history',           name:'history',             component: () => import('@/views/company/history.vue'),
  //   meta: {
  //     cate: 1,
  //     pageTitle: 'History', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Company',
  //         disabled: false,
  //       },
  //       {
  //         text: 'History',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  // { path: '/company/customer',          name:'customer',            component: () => import('@/views/company/customer.vue'),
  //   meta: {
  //     cate: 1,
  //     pageTitle: 'Customer / Partner', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Company',
  //         disabled: false,
  //       },
  //       {
  //         text: 'Customer / Partner',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  // { path: '/company/location',          name:'location',            component: () => import('@/views/company/location.vue'),
  //   meta: {
  //     cate: 1,
  //     pageTitle: 'Location', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Company',
  //         disabled: false,
  //       },
  //       {
  //         text: 'Location',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },


  { path: '/service',                   name:'service',             component: () => import('@/views/service.vue'),
    meta: {
      cate: 2,
      pageTitle: 'Our Specialized IT Solutions', 
      breadcrumb: [
        { 
          text: 'Home',
          disabled: false,
          to: '/'
        },
        { 
          text: 'Service',
          disabled: false,
        },
        {
          text: 'Our Specialized IT Solutions',
          disabled: false,
        },
      ],
    },
  },
  // { path: '/service/solutions',         name:'solutions',           component: () => import('@/views/service/solutions.vue'),
  //   meta: {
  //     cate: 2,
  //     pageTitle: 'Our Specialized IT Solutions', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Service',
  //         disabled: false,
  //       },
  //       {
  //         text: 'Our Specialized IT Solutions',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  // { path: '/service/transformation',    name:'transformation',      component: () => import('@/views/service/transformation.vue'),
  //   meta: {
  //     cate: 2,
  //     pageTitle: 'Digital Transformation', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Service',
  //         disabled: false,
  //       },
  //       {
  //         text: 'Digital Transformation',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  // { path: '/service/integration',       name:'integration',         component: () => import('@/views/service/integration.vue'),
  //   meta: {
  //     cate: 2,
  //     pageTitle: 'System Integration', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Service',
  //         disabled: false,
  //       },
  //       {
  //         text: 'System Integration',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  // { path: '/service/consulting',        name:'consulting',          component: () => import('@/views/service/consulting.vue'),
  //   meta: {
  //     cate: 2,
  //     pageTitle: 'IT Consulting', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Service',
  //         disabled: false,
  //       },
  //       {
  //         text: 'IT Consulting',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  // { path: '/service/outsourcing',       name:'outsourcing',         component: () => import('@/views/service/outsourcing.vue'),
  //   meta: {
  //     cate: 2,
  //     pageTitle: 'IT Outsourcing', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Service',
  //         disabled: false,
  //       },
  //       {
  //         text: 'IT Outsourcing',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },



  { path: '/product',                   name:'product',             component: () => import('@/views/product.vue'),
    meta: {
      cate: 3,
      pageTitle: 'JBot(RPA)', 
      breadcrumb: [
        { 
          text: 'Home',
          disabled: false,
          to: '/'
        },
        { 
          text: 'Product',
          disabled: false,
        },
        {
          text: 'JBot(RPA)',
          disabled: false,
        },
      ],
    },
  },
  // { path: '/product/jbot',              name:'jbot',                component: () => import('@/views/product/jbot.vue'),
  //   meta: {
  //     cate: 3,
  //     pageTitle: 'JBot(RPA)', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Product',
  //         disabled: false,
  //       },
  //       {
  //         text: 'JBot(RPA)',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  // { path: '/product/jbotportal',        name:'jbotportal',          component: () => import('@/views/product/jbotportal.vue'),
  //   meta: {
  //     cate: 3,
  //     pageTitle: 'JBot Portal(RPA)', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Product',
  //         disabled: false,
  //       },
  //       {
  //         text: 'JBot Portal(RPA)',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  // { path: '/product/autostation',       name:'autostation',         component: () => import('@/views/product/autostation.vue'),
  //   meta: {
  //     cate: 3,
  //     pageTitle: 'Auto-Station', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Product',
  //         disabled: false,
  //       },
  //       {
  //         text: 'Auto-Station',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  // { path: '/product/brityrpa',          name:'brityrpa',            component: () => import('@/views/product/brityrpa.vue'),
  //   meta: {
  //     cate: 3,
  //     pageTitle: 'SAMSUNG SDS Brity RPA', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Product',
  //         disabled: false,
  //       },
  //       {
  //         text: 'SAMSUNG SDS Brity RPA',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  // { path: '/product/brityassistant',    name:'brityassistant',      component: () => import('@/views/product/brityassistant.vue'),
  //   meta: {
  //     cate: 3,
  //     pageTitle: 'SAMSUNG SDS Brity Assistant', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Product',
  //         disabled: false,
  //       },
  //       {
  //         text: 'SAMSUNG SDS Brity Assistant',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  // { path: '/product/tibco',             name:'tibco',               component: () => import('@/views/product/tibco.vue'),
  //   meta: {
  //     cate: 3,
  //     pageTitle: 'TIBCO', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Product',
  //         disabled: false,
  //       },
  //       {
  //         text: 'TIBCO',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  // { path: '/product/jsf',               name:'jsf',                 component: () => import('@/views/product/jsf.vue'),
  //   meta: {
  //     cate: 3,
  //     pageTitle: 'JSF(Jein SAP Interface Framework)', 
  //     breadcrumb: [
  //       { 
  //         text: 'Home',
  //         disabled: false,
  //         to: '/'
  //       },
  //       { 
  //         text: 'Product',
  //         disabled: false,
  //       },
  //       {
  //         text: 'JSF(Jein SAP Interface Framework)',
  //         disabled: false,
  //       },
  //     ],
  //   },
  // },
  
  
  
  { path: '/contactus',                 name:'contactus',           component: () => import('@/views/contactus.vue'),
    meta: {
      cate: 4,
      pageTitle: 'Contact Us', 
      breadcrumb: [
        { 
          text: 'Home',
          disabled: false,
          to: '/'
        },
        { 
          text: 'Contact Us',
          disabled: false,
        },
      ],
    },
  },
  { path: '/:catchAll(.*)*',            name:'error404',            component: () => import('@/views/Error404.vue') },
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 90 },
        behavior: 'smooth'
      };
    }
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes
})

export default router
